let isDebuggerProduction = false; // 本地调试线上环境
let isProxy = true; // 是否使用webpack的代理
let proxyMap = {
  production: {
    api: 'https://api.elfinbook.com/',
    oss1: 'https://cdn.elfinbook.com/'
  },
  dev: {
    api: 'http://api.book.com/',
    oss1: 'http://elfinbook-test.oss-cn-shanghai.aliyuncs.com/',
    oss1_reg: /http(s)?:\/\/elfinbook-test.oss-cn-shanghai\.aliyuncs\.com/g,
    oss2: 'http://elfinbook-test-public.oss-cn-shanghai.aliyuncs.com/',
    oss2_reg: /http(s)?:\/\/elfinbook-test-public.oss-cn-shanghai.aliyuncs\.com/g
  }
};
const proxySetting = proxyMap[isDebuggerProduction ? 'production' : 'dev'];
// console.log('proxySetting', proxySetting);
let buildForTest = false;
if (process.env.build_mode == 'test') {
  isProxy = false;
  buildForTest = true;
}

module.exports = {
  proxySetting,
  isDebuggerProduction,
  isProxy,
  buildForTest,
  lastUpdateDateTime: '2025-12-06 18:00:00'
};
